import script from "./PlayButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlayButton.vue?vue&type=script&lang=ts&setup=true"

import "./PlayButton.vue?vue&type=style&index=0&id=e88bb74a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e88bb74a"]])

export default __exports__